import * as React from "react";
import type { SVGProps } from "react";

const SvgStdInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={35}
    height={35}
    viewBox="0 0 48 48"
    {...props}
  >
    <g transform="translate(11 11)">
      <circle cx={13} cy={13} r={13} fill="#142745" />
      <path
        fill="#FFF"
        d="M14.97 21.667h-3.94v-9.603l-1.97-.246v-1.97h5.91v9.603l1.97.246v1.97zm0-15.758q0 .893-.547 1.43-.548.54-1.491.54-.87 0-1.386-.54-.516-.537-.516-1.43 0-.891.522-1.43.522-.54 1.38-.54.944 0 1.49.54.548.539.548 1.43"
      />
    </g>
  </svg>
);
export default SvgStdInfo;
